import { SnackbarModel } from '@/common/types'
import {
  getSimilarProducts,
  getSimilarProducts_similarProductsBy,
  getSimilarProducts_similarProductsBy_items
} from '@/product/queries/types/getSimilarProducts'
import {
  addonProductsResolver,
  addonProductsResolver_addonProducts,
  addonProductsResolver_addonProducts_sku_firstOptions
} from '@/product/queries/types/addonProductsResolver'
import {
  productDetail_productByPrintableSku,
  productDetail_productByPrintableSku_estimate,
  productDetail_productByPrintableSku_product,
  productDetail_productByPrintableSku_sku,
  productDetail,
  productDetail_productByPrintableSku_sku_skuImages,
  productDetail_productByPrintableSku_sku_availableSizes,
  productDetail_productByPrintableSku_sku_skuColorPatterns,
  productDetail_productByPrintableSku_sku_skuEditPatterns,
  productDetail_productByPrintableSku_sku_mappedSizeSpecs,
  productDetail_productByPrintableSku_searchTags,
  productDetail_productByPrintableSku_product_productCardItems
} from '@/product/queries/types/productDetail'
import {
  prefecturesResolver,
  prefecturesResolver_prefectures
} from '@/product/queries/types/prefecturesResolver'
import {
  additionalOptionsResolver
} from '@/product/queries/types/additionalOptionsResolver'
import { AdditionalOption } from '@/common/types'
import { getProductRelatedCategories_productRelatedCategories } from '@/product/queries/types/getProductRelatedCategories'
export interface SkuSize extends productDetail_productByPrintableSku_sku_availableSizes {
  quantity: number
}

export type SizeSpec = productDetail_productByPrintableSku_sku_mappedSizeSpecs

export type ProductDetailModel = Omit<productDetail_productByPrintableSku, 'estimate'>
export type ProductDetailModelFull = productDetail_productByPrintableSku
export type ProductDetailResponse = productDetail
export type ProductInfo = productDetail_productByPrintableSku_product
export type ProductSku = productDetail_productByPrintableSku_sku
export type ProductEstimate = productDetail_productByPrintableSku_estimate
export type ProductSkuImage = productDetail_productByPrintableSku_sku_skuImages
export type ProductColorPattern = productDetail_productByPrintableSku_sku_skuColorPatterns
export type ProductEditPattern = productDetail_productByPrintableSku_sku_skuEditPatterns

export type AddonProductResponse = addonProductsResolver
export type AddonProduct = addonProductsResolver_addonProducts
export type AddonProductFirstOption = addonProductsResolver_addonProducts_sku_firstOptions
export type ProductSearchTag = productDetail_productByPrintableSku_searchTags
export type SimilarProducts = getSimilarProducts_similarProductsBy
export type SimilarProductItem = getSimilarProducts_similarProductsBy_items
export type SimilarProductResponse = getSimilarProducts
export type ProductCardFunction = productDetail_productByPrintableSku_product_productCardItems
export type PrefectureResponse = prefecturesResolver
export type Prefecture = prefecturesResolver_prefectures
export type AdditionalOptionsResponse = additionalOptionsResolver
export type RelatedCategory = getProductRelatedCategories_productRelatedCategories

export type AddonProductOption = {
  selectedAddonProductId?: string
  selectedAddonFirstOptionId?: string
}

export type StockLibraryDesign = {
  uuid?: string
  isDefault?: boolean
  imageUrl?: string
  userDesignVersionUuid?: string
}
export enum PRODUCT_SELECTION_ERROR_TYPES {
  PRODUCT_SIZE = 'productSize',
  PRODUCT_SET = 'productSet',
  PRINTING_OPTION = 'printingOption'
}

export interface FormattedColorPatternOption {
  id: string
  displayName: string
  image: string
  price: string
  explanation: string
  description: string
  colorType: {
    name: string
    icon: string
  }
}

export type ProductSelectionError = {
  errorMessage: string
  highlightInvalidElement: boolean
}

export interface BuyingOption {
  displayName: string
  subText?: string
  isBuying: boolean | string
  isDisabled: boolean
}

export interface ProductState {
  productDetail: ProductDetailModel
  estimate: ProductEstimate
  imageLoading: boolean
  validQuantity: boolean
  serverError: boolean
  productLoading: boolean
  sizeInput: any[]
  addonProducts: AddonProduct[]
  addonProduct: AddonProductOption
  additionalOptions: AdditionalOption[]
  selectedAdditionalOptionIds: string[]
  prefectureId?: string
  isPrintingSelected: boolean
  stockLibraryDesign: StockLibraryDesign
  selectionErrors: { [key: string]: ProductSelectionError }
  isMobileView: boolean
  snackbarMessage: SnackbarModel
  maxQuantity: number
}
